import { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Homepage } from './views/Homepage';
import { VaultPrivacy } from './views/VaultPrivacy';
import { VaultSupport } from './views/VaultSupport';

const THEME_STORAGE_KEY = 'devph-theme';

const getInitialTheme = () => {
  try {
    const savedTheme = window.localStorage.getItem(THEME_STORAGE_KEY);
    if (savedTheme === 'light' || savedTheme === 'dark') {
      return savedTheme;
    }
  } catch (error) {
    // Ignore storage access errors and use default theme.
  }

  return 'dark';
};

function App() {
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    try {
      window.localStorage.setItem(THEME_STORAGE_KEY, theme);
    } catch (error) {
      // Ignore storage access errors.
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme((currentTheme) => (currentTheme === 'dark' ? 'light' : 'dark'));
  };

  return (
    <Routes>
      <Route path='/' element={<Homepage theme={theme} onToggleTheme={toggleTheme} />} />
      <Route path='/vault' element={<Navigate to='/vault/support' replace />} />
      <Route path='/vault/privacy' element={<VaultPrivacy theme={theme} onToggleTheme={toggleTheme} />} />
      <Route path='/vault/support' element={<VaultSupport theme={theme} onToggleTheme={toggleTheme} />} />
    </Routes>
  );
}

export default App;
